import {LinkGroup} from 'shared/pretty-easy-navigation/models';
import {ContactLink, LearnerAppLink, LegalMentionsLink} from '../links';
import {NavigationContext} from '../navigation.context';
import {SiteMapLink} from "../links/site-map.link";

export const TrainerFooterGroup = (context: NavigationContext): LinkGroup => ({
    type: 'linkGroup',
    links: [
        LearnerAppLink(context),
        ContactLink(context),
        LegalMentionsLink(context),
        SiteMapLink(context, 'trainer')
    ]
});